document.addEventListener("DOMContentLoaded", function () {
  var mySwiper = new Swiper(".ctm_bestseller_slider", {
    slidesPerView: 3,
    spaceBetween: 40,
    loop: false,
    speed: 1000,
    navigation: {
      nextEl: ".ctm_bestseller_next",
      prevEl: ".ctm_bestseller_prev",
    },

    breakpoints: {
      1440: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 25,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 18,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 18,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 18,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 28,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  });
  //live online class
  var mySwiper = new Swiper(".ctm_online_class_grid .ctm_bestseller_slider", {
    slidesPerView: 4,
    spaceBetween: 40,
    loop: false,
    speed: 1000,
    navigation: {
      nextEl: ".ctm_bestseller_next",
      prevEl: ".ctm_bestseller_prev",
    },

    breakpoints: {
      1440: {
        slidesPerView: 4,
        spaceBetween: 30,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 30,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 18,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      576: {
        slidesPerView: 1,
        spaceBetween: 18,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      414: {
        slidesPerView: 1,
        spaceBetween: 18,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 28,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  });

  //why cindrella skider
  var mySwiper = new Swiper(".why-cindrella-inner_grid.cindrella_slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    grabCursor: true,
    freeMode: false,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".cindrella_slider_next",
      prevEl: ".cindrella_slider_prev",
    },

    breakpoints: {
      1366: {
        slidesPerView: 4,
      },
      1280: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
  //why cindrella online class slider
  var mySwiper = new Swiper(".ctm_online_why_hair .cindrella_slider", {
    slidesPerView: 6,
    spaceBetween: 20,
    loop: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    grabCursor: true,
    freeMode: false,
    speed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".cindrella_slider_next",
      prevEl: ".cindrella_slider_prev",
    },

    breakpoints: {
      1366: {
        slidesPerView: 6,
      },
      1280: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  //blog slider
  var mySwiper = new Swiper(".blog_slider", {
    slidesPerView: 3,
    spaceBetween: 40,
    loop: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    grabCursor: false,
    freeMode: false,
    speed: 1000,
    navigation: {
      nextEl: ".blog_slider_next",
      prevEl: ".blog_slider_prev",
    },
    breakpoints: {
      1280: {
        slidesPerView: 3,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      768: {
        slidesPerView: 2.5,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      575: {
        slidesPerView: 1.5,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
      0: {
        slidesPerView: 1,
        centeredSlides: false,
        centeredSlidesBounds: false,
      },
    },
  });

  //stylist client say
  var mySwiper = new Swiper(".stylist-clients", {
    slidesPerView: 4,
    spaceBetween: 20,
    loop: true,
    centeredSlides: false,
    centeredSlidesBounds: false,
    grabCursor: true,
    freeMode: false,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1366: {
        slidesPerView: 4,
      },
      1280: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  // video play on svg better than a veft page
  if (document.querySelectorAll(".video-with-text").length) {
    const video = document.getElementById("bettervideo");
    const circlePlayButton = document.getElementById("circle-play-b");

    function togglePlay() {
      if (video.paused || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    }

    circlePlayButton.addEventListener("click", togglePlay);

    circlePlayButton.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        togglePlay();
      }
    });

    video.addEventListener("playing", function () {
      circlePlayButton.style.opacity = 0;
    });

    video.addEventListener("pause", function () {
      circlePlayButton.style.opacity = 1;
    });
  }

  // video play on svg better than a veft page
  const videos = document.querySelectorAll(".video-image-wrapper video");
  const playButtons = document.querySelectorAll(".deferred-media__poster");

  if (videos.length > 0 && playButtons.length > 0) {
    videos.forEach((video, index) => {
      const playButton = playButtons[index];

      if (playButton) {
        function togglePlay() {
          if (video.paused || video.ended) {
            video.play();
          } else {
            video.pause();
          }
        }

        playButton.addEventListener("click", togglePlay);
        video.addEventListener("playing", () => {
          playButton.style.opacity = 0;
        });
        video.addEventListener("pause", () => {
          playButton.style.opacity = 1;
        });
        video.addEventListener("click", togglePlay);
      }
    });
  }

  //People Video BLock
  var mySwiper = new Swiper(".ctm_peopletalking_slider ", {
    slidesPerView: 3,
    spaceBetween: 40,
    loop: true,
    centeredSlides: false,
    centeredSlidesBounds: false,
    grabCursor: true,
    freeMode: false,
    speed: 1000,
    navigation: {
      nextEl: ".people_talking_next",
      prevEl: ".people_talking_prev",
    },
    breakpoints: {
      1366: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
    },
  });

  var mySwiper = new Swiper(".stylists_saying_slider", {
    slidesPerView: 3,
    spaceBetween: 10,
    loop: true,
    grabCursor: true,
    speed: 1000,
    navigation: {
      nextEl: ".stylists_next",
      prevEl: ".stylists_prev",
    },
    breakpoints: {
      1366: {
        slidesPerView: 3,
      },
      1280: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 2,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  // Function to wait for an element to be available in the DOM
  function waitForElement(selector) {
    return new Promise((resolve) => {
      function checkElement() {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
        } else {
          requestAnimationFrame(checkElement);
        }
      }
      checkElement();
    });
  }

  // Function to initialize Swiper when the element is available
  async function initializeSwiper() {
    const swiperSelector = ".related-product__slider";

    const swiperElement = await waitForElement(swiperSelector);

    new Swiper(swiperElement, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1366: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
        },
        640: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  }

  initializeSwiper();

  // Header sticky
  $(window).scroll(function () {
    if ($(this).scrollTop() > 40) {
      $(".ctm_header_wrapper").addClass("menufixed");
      $("body").addClass("header-fixed");
      $("body").addClass("cart-top");
    } else {
      $(".ctm_header_wrapper").removeClass("menufixed");
      $("body").removeClass("header-fixed");
      $("body").removeClass("cart-top");
    }
  });

  // Header account-popup
  $(".login_popup").click(function () {
    if ($(this).hasClass("active")) {
      // If the login popup is already active, we should close it
      $(this).removeClass("active");
      $(".customer-account").addClass("hidden");
      $(".customer-account").removeClass("login-left");
      $("body").removeClass("overflow-hidden");
      $("#shopify-section-account-popup").hide();
      $(".ctm-login-modal-bg").removeClass("active");
    } else {
      // If the login popup is not active, we should open it
      $(this).addClass("active");
      $(".customer-account").removeClass("hidden");
      $("#shopify-section-account-popup").show();
      $(".ctm-login-modal-bg").addClass("active");
      $(".customer-account").addClass("login-left");
      $("body").addClass("overflow-hidden");

      // Close the cart drawer if it's open
      if ($(".ctm_cartdrawer").hasClass("active")) {
        $(".ctm_cartdrawer").removeClass("active");
      }
    }
  });

  $(".ctm-login-modal-bg").click(function () {
    $(this).removeClass("active");
    $(".customer-account").addClass("hidden");
    $(".customer-account").removeClass("login-left");
    $(".login_popup").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $("#shopify-section-account-popup").hide();
  });

  $("#login-none").click(function () {
    $(".login-cta").addClass("d-none");
    $(".reset-password").removeClass("d-none");
  });
  $("#recover-cancel").click(function () {
    $(".login-cta").removeClass("d-none");
    $(".reset-password").addClass("d-none");
  });

  $("#regi_forgot_pass").click(function () {
    $("#img-1").addClass("current");
    $("#tab-1").addClass("current");
    $("#login").addClass("current");
    $("#img-2").removeClass("current");
    $("#tab-2").removeClass("current");
    $("#signup").removeClass("current");
  });
  $("#regi-recover-cancel").click(function () {
    $(".reset-password").addClass("d-none");
    $(".forgot-block-area").removeClass("d-none");
  });

  // popup tabbing
  $(".tab-heading ul li a").click(function () {
    var tab_idd = $(this).attr("data-tab");
    var tab_img = $(this).attr("data-img");

    $(".reset-password").addClass("d-none");
    $(".login-cta").removeClass("d-none");
    $(".forgot-block-area").removeClass("d-none");

    $(".tab-heading ul li a").removeClass("current");
    $(".account-tab.tab-pane").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_idd).addClass("current");
    $("#" + tab_img).addClass("current");
  });

  $("a.mega-menu__link.ctm-megamenu-link").mouseenter(function () {
    $("a.mega-menu__link.ctm-megamenu-link").removeClass("active");
    $(this).addClass("active");
    var data = $(this).data("dropdown-rel");
    var $menuContent = $(this).closest(".mega-menu__content");
    $menuContent.find(".megamenu-content").addClass("hidden invisible");
    $menuContent
      .find('.megamenu-content[data-dropdown="' + data + '"]')
      .removeClass("hidden invisible");
  });

  /** Megamenu start **/

  // Hover event for .header__inline-menu a
  $(".header__inline-menu a").hover(
    function () {
      var data = $(this).data("dropdown-rel");

      // Remove active class and hide all mega-menu sections
      $(".header__inline-menu a").removeClass("menu_active");
      $(".mega-menu")
        .parent(".mega-menu-section")
        .addClass("opacity-0 h-0 invisible");

      // Add active class to the hovered link
      $(this).addClass("menu_active");

      // Show the related mega-menu section
      $('.mega-menu[data-dropdown="' + data + '"]')
        .parent(".mega-menu-section")
        .removeClass("opacity-0 h-0 invisible");

      // Add overflow-hidden class to body
      // $("body").addClass("overflow-hidden");
    },
    function () {
      // Handle hover out: check if any .mega-menu or .header__inline-menu a is still being hovered
      setTimeout(function () {
        if (
          !$(".header__inline-menu a:hover").length &&
          !$(".mega-menu:hover").length
        ) {
          $("body").removeClass("overflow-hidden");
          $(".header__inline-menu a").removeClass("menu_active");
          $(".mega-menu")
            .parent(".mega-menu-section")
            .addClass("opacity-0 h-0 invisible");
        }
      }, 100); // Adjust timeout if needed
    },
  );

  // Hover event for .mega-menu to manage body class
  $(".mega-menu").hover(
    function () {
      // Check if the hovered .mega-menu has a child <a> with data-mega-menu
      if ($(this).find("a[data-mega-menu]").length) {
        $("body").addClass("menu_active");
      }
    },
    function () {
      // Remove body class only if no relevant .mega-menu is being hovered
      setTimeout(function () {
        if (
          !$(".mega-menu:hover").length &&
          !$(".header__inline-menu a:hover").length
        ) {
          $("body").removeClass("menu_active");
        }
      }, 100); // Adjust timeout if needed
    },
  );

  $(".header__inline-menu")
    .mouseleave(function () {
      if ($(".mega-menu-section:hover").length == 0) {
        $(".mega-menu")
          .parent(".mega-menu-section")
          .addClass("opacity-0 h-0 invisible");
        $("body").removeClass("overflow-hidden");
        $(".header__inline-menu a").removeClass("menu_active");
      }
    })
    .mouseleave();

  $(".mega-menu-section")
    .mouseleave(function () {
      $(this).addClass("opacity-0 h-0 invisible");
      $("body").removeClass("overflow-hidden");
      $(".header__inline-menu a").removeClass("menu_active");
    })
    .mouseleave();

  $(".header-dropdown").mouseenter(function () {
    $(".mega-menu")
      .parent(".mega-menu-section")
      .addClass("opacity-0 h-0 invisible");
  });

  $(document)
    .on("mouseenter", ".header__inline-menu ul li a", function (event) {
      if ($(".mega-menu-section").hasClass("hiddens")) {
      } else {
        $(".dropdown_content .dropdown_column")
          .not(this)
          .removeClass("first_active");
        $(".dropdown_content .dropdown_column.dropdown1").addClass(
          "first_active",
        );

        $(".menu_img_wrapper").not(this).removeClass("firstimage_active");
        $(".menu_img_wrapper.menu_img_wrapper1").addClass("firstimage_active");
      }
    })
    .on("mouseleave", ".header__inline-menu ul li a", function () {
      if ($(".mega-menu-section").hasClass("hiddens")) {
      } else {
        $(".dropdown_content .dropdown_column").removeClass("first_active");
        ".menu_img_wrapper".removeClass("firstimage_active");
      }
    });

  //mega menu active class on hover
  // active product menu

  // on hover
  $(".dropdown_content .dropdown_column").hover(
    function () {
      $(this).addClass("ctm-Classactive");
    },
    function () {
      $(this).removeClass("ctm-Classactive");
    },
  );

  $(".dropdown_content .dropdown_column").hover(function () {
    var megaMenu = $(this).closest(".dropdown_container");
    console.log($(this).attr("data-submenu-index"));
    megaMenu.find(".menu_img_wrapper").removeClass("ctm-menu_img_wrapper");
    megaMenu
      .find(
        ".menu_img_wrapper[data-index='" +
          $(this).attr("data-submenu-index") +
          "']",
      )
      .addClass("ctm-menu_img_wrapper");
  });

  $(document).ready(function () {
    const parentDiv = $(
      ".dropdown_container .dropdown-content .ctm-Classactive",
    ).closest(".megamenu-content");

    if (parentDiv.length > 0) {
      const dropdownValue = parentDiv.attr("data-dropdown");
      const anchorElement = $(`a[data-dropdown-rel="${dropdownValue}"]`);
      if (anchorElement.length > 0) {
        anchorElement.addClass("header__active-menu-item");
      }
    }
  });

  // MEGA MENU ACTIVE LINK
  $(".mega-menu [href]").each(function () {
    if (this.href == window.location.href) {
      $(".dropdown_column").removeClass("product_menu_active");
      $(this)
        .closest(".mega-menu__image-caption-link")
        .parents(".dropdown_column")
        .addClass("product_menu_active");
    }
  });
  $(".ctm_click_megamenu [href]").each(function () {
    if (this.href == window.location.href) {
      $(".dropdown_column").removeClass("product_menu_active_mob");
      $(this)
        .closest(".mega-menu__image-caption-link")
        .parents(".dropdown_column")
        .addClass("product_menu_active_mob");
      if ($(".dropdown_column").hasClass("product_menu_active_mob")) {
        $(this).closest("li").addClass("pdp_active");
        $(".product_menu_active_mob")
          .parentsUntil(".ctm_click_megamenu")
          .parent("li")
          .addClass("pdp_active");
      }
    }
  });

  setTimeout(function () {
    var check_class = $(
      ".dropdown_container.mega-menu .dropdown_content .product_menu_active",
    ).length;

    if (check_class == 1) {
      var menu_nm = $(".dropdown_container.mega-menu").data("dropdown");
      $(".headermenu_list li").each(function () {
        var drop_rel = $(this).find("a").data("dropdown-rel");
        if (menu_nm == drop_rel) {
          $(this).find("span").addClass("header__active-menu-item");
        }
      });
    }
  }, 1500);

  // // mobile sub-menu hide show
  $(".menu-drawer__menu .ctm_click").on("click", function () {
    if ($(this).children(".drop-box-ctm").hasClass("submenu-open-ctm")) {
      $(this).children(".drop-box-ctm").removeClass("submenu-open-ctm");
      setTimeout(function () {
        $(this).children(".drop-box-ctm").removeAttr("open");
      }, 1000);
    } else {
      $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeClass(
        "submenu-open-ctm",
      );
      $(".menu-drawer__menu .ctm_click .drop-box-ctm").removeAttr("open");
      $(this).children(".drop-box-ctm").addClass("submenu-open-ctm");
      $(this).children(".drop-box-ctm").attr("open");
    }
  });

  /** Megamenu end **/

  // FAQ for PDP
  document.querySelectorAll(".ctm_faq_title_inner").forEach((section) => {
    let questions = section.querySelectorAll(".faq_question");
    let previousActiveQuestion = null;

    questions.forEach((question) => {
      let icon = question.querySelector(".icon-shape");

      question.addEventListener("click", (event) => {
        if (previousActiveQuestion && previousActiveQuestion !== question) {
          previousActiveQuestion.classList.remove("active");
          previousActiveQuestion
            .querySelector(".icon-shape")
            .classList.remove("active");
          previousActiveQuestion.nextElementSibling.style.maxHeight = 0;
        }

        question.classList.toggle("active");
        icon.classList.toggle("active");

        const answer = question.nextElementSibling;

        if (question.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + "px";
          previousActiveQuestion = question; // Update the previously active question
        } else {
          answer.style.maxHeight = 0;
          previousActiveQuestion = null; // No question is active now
        }
      });

      // Check if the question has the "open" class and add the "active" class accordingly
      if (question.classList.contains("open")) {
        question.classList.add("active");
        icon.classList.add("active");
        const answer = question.nextElementSibling;
        answer.style.maxHeight = answer.scrollHeight + "px";
        previousActiveQuestion = question; // Set the initially active question
      }
    });
  });

  //footer menu js
  $(".footer-block").click(function () {
    var targetFooterBlock = $(this).closest(".footer-block");
    var targetDetailsContent = targetFooterBlock.find(
      "ul.footer-block__details-content",
    );
    $(".footer-block").not(targetFooterBlock).removeClass("show");
    $("ul.footer-block__details-content")
      .not(targetDetailsContent)
      .removeClass("show");
    targetFooterBlock.toggleClass("show");
    targetDetailsContent.toggleClass("show");
  });
  $(".footer-block").keydown(function (e) {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default action for Enter key
      $(this).click(); // Trigger the click event
    }
  });

  // Get the current window URL
  const swatchContainers = document.querySelectorAll(
    ".texture-block__straight, .texture-block__body, .texture-block__euro ",
  );
  const currentUrl = window.location.href.split("?")[0];
  const currentSlug = currentUrl.split("/products/")[1]; // get handle part
  swatchContainers.forEach((container) => {
    const links = container.querySelectorAll("a");
    links.forEach((link) => {
      const linkHref = link.getAttribute("href");
      if (!linkHref) return;

      const linkSlug = linkHref.split("/products/")[1];
      if (linkSlug === currentSlug) {
        link.classList.add("pdp_swatch_active");
      } else {
        link.classList.remove("pdp_swatch_active"); // optional: cleanup others
      }
    });
  });
});

// //load more products

$(".ctm_productgrid_list").hide();
$(".ctm_productgrid_list").slice(0, 12).show();
function toggleLoadMoreButton() {
  if ($(".ctm_productgrid_list:hidden").length > 0) {
    $(".blog-loadmore-btn").show();
  } else {
    $(".blog-loadmore-btn").hide();
  }
}
toggleLoadMoreButton();
$("body").on("click touchstart", "#load-more", function (e) {
  e.preventDefault();
  $(".ctm_productgrid_list:hidden").slice(0, 6).slideDown();
  toggleLoadMoreButton();
});

// terms-condition
// const checkbox = document.getElementById('termsCheckbox');
//     const addToCartButton = document.querySelector('.ProductButton');
//     addToCartButton.addEventListener('click', function () {
//       if (checkbox.checked) {
//         addToCartButton.closest('form').submit();
//       }
//     });
//     checkbox.addEventListener('change', function () {
//       if (checkbox.checked) {
//         addToCartButton.classList.add('ctm-pdp-checked')
//         addToCartButton.removeAttribute('disabled');
//       } else {
//         addToCartButton.classList.remove('ctm-pdp-checked')
//         addToCartButton.setAttribute('disabled',false);

//       }
//     });

// Navigation active

const parentDiv = $(".dropdown_container .ctm_menu_active_inner").closest(
  ".mega-menu",
);
if (parentDiv.length > 0) {
  const dropdownValue = parentDiv.attr("data-dropdown");
  const anchorElement = $(`a[data-dropdown-rel="${dropdownValue}"]`);
  if (anchorElement.length > 0) {
    anchorElement.addClass("ctm_menu_active");
  }
}

// Master Class ATC BUTTON
document.addEventListener("DOMContentLoaded", function () {
  if (document.body.classList.contains("ctm_tem_master")) {
    const termsCheckbox = document.getElementById("termsCheckbox");
    const addToCartButton = document.querySelector(
      "button.ProductButton.product-form__submit",
    );

    if (termsCheckbox && addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.style.filter = "grayscale(100%)";
      addToCartButton.style.cursor = "not-allowed";

      termsCheckbox.addEventListener("change", function () {
        if (termsCheckbox.checked) {
          addToCartButton.disabled = false;
          addToCartButton.style.filter = "none";
          addToCartButton.style.cursor = "pointer";
        } else {
          addToCartButton.disabled = true;
          addToCartButton.style.filter = "grayscale(100%)";
          addToCartButton.style.cursor = "not-allowed";
        }
      });
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const swatches = document.querySelectorAll(".variant-swatch");
  const descriptionEl = document.getElementById("variant-description");

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const desc = this.getAttribute("data-description") || "";
      descriptionEl.textContent = desc;

      // Optional: add selected style
      swatches.forEach((el) => el.classList.remove("selected"));
      this.classList.add("selected");
    });
  });
});
